import { render, staticRenderFns } from "./PortalUserAutocomplete.vue?vue&type=template&id=bb0c3cf6&"
import script from "./PortalUserAutocomplete.vue?vue&type=script&lang=js&"
export * from "./PortalUserAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports